import { InputOtp } from '@heroui/react';
import { useTimer } from 'hooks';
import { LuLock } from 'react-icons/lu';

interface TokenAuthProps {
    pinValue: string;
    handlePinValue: (value: string) => void;
    status: number;
    loading: boolean;
    handleReset: () => void;
}

const TokenAuth = ({ pinValue, handlePinValue, status, loading, handleReset }: TokenAuthProps) => {
    const { progress } = useTimer(30, handleReset);
    const errorToken = status > 2;

    return (
        <div className="flex justify-center items-center w-full h-full">
            <div className="flex flex-col p-4 rounded-2xl bg-default-100 w-full  max-w-87.5 min-w-52 z-1 ">
                <div className="flex flex-col items-center w-full">
                    <div className="flex justify-center">
                        {/* <MdLock className="text-[120px] text-[#b5b5b5]" /> */}
                        <LuLock className='h-20 w-20' />
                    </div>
                    <div className="pt-4 text-center">
                        <h6 className="text-lg font-bold">Página restingida</h6>
                    </div>
                    <div className="text-center">
                        <span className="text-sm text-[#757575]">{`Redireccionando en ${progress}`}</span>
                    </div>

                    <div className="pb-5 text-center">
                        <span className="text-xs text-[#666666]">Por favor ingrese pin de seguridad:</span>
                    </div>

                    {errorToken && (
                        <div className="pb-1 text-center">
                            <strong className="text-xs text-[#E64A3B]">
                                {status === 4 ? 'Ha ocurrido un error, porfavor intente de nuevo.' : 'Pin inválido'}
                            </strong>
                        </div>
                    )}
                    <div className='w-full flex justify-center items-center'>
                        <InputOtp
                            length={4}
                            value={pinValue}
                            classNames={{
                                base: `flex flex-col items-center`
                            }}
                            onValueChange={handlePinValue}
                            isDisabled={loading}
                            isInvalid={errorToken}    
                            disabled={loading}
                            color='success'
                            type="password"
                            variant='bordered'
                            onComplete={() => {
                                if (document.activeElement instanceof HTMLElement) {
                                    document.activeElement.blur();
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TokenAuth;
